let mediaGallery = {};
const mediaSlider = document.querySelector('.media_gallery_grid');
const prevButton = mediaSlider.querySelector('.slider-button--prev');
const nextButton = mediaSlider.querySelector('.slider-button--next');

// counter
let currentItem = 4;
let startItem = 1;
let totalItem = 0;

function allElements(selectedVariantGallery) {
  mediaGallery = selectedVariantGallery;
  totalItem = mediaGallery.length;
  selectedVariantGallery.forEach((element, index) => {
    if (index >= 4) {
      element.classList.add('hidden');
    }
  });

  setTimeout(()=>{
    enableButtons();
  },1000)
}

prevButton.addEventListener('click', handlePrevClick);
nextButton.addEventListener('click', handleNextClick);

function handlePrevClick() {
  if (startItem > 1) {
    startItem--;
    currentItem--;
    updateGallery();
  }
}

function handleNextClick() {
  if (currentItem < totalItem) {
    startItem++;
    currentItem++;
    updateGallery();
  }
}

function updateGallery() {
  mediaGallery.forEach((element, index) => {
    if (index < startItem - 1 || index >= currentItem) {
      element.classList.add('hidden');
    } else {
      element.classList.remove('hidden');
    }
  });

  enableButtons();
}

function enableButtons() {
  prevButton.disabled = startItem === 1;
  nextButton.disabled = currentItem === totalItem;
}
